import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: "#fff",
    },
    background: {
      default: "#1C1C1C",
    },
    text: {
      primary: "#fff",
      secondary: '#ABABAB',
    },
  },
  typography: {
    fontFamily: "Montserrat",
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: '#1c1c1c'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          color: 'white',
          background: 'rgba(120,120,120,0.25)',
        }
      }
    },
  }
});

export default theme;